<template>
  <v-container fluid class="fill-height">
    <v-row justify="center" align="center">
      <v-col cols="auto">
        <v-card width="400px">
          <v-toolbar flat dark color="blue darken-3">
            <v-toolbar-title class="mx-auto">
              ACCESO AL SISTEMA
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="email"
              autofocus
              label="Usuario"
              prepend-icon="account_circle"
              required
            >
            </v-text-field>
            <v-text-field
              v-model="password"
              label="Contraseña"
              prepend-icon="https"
              :append-icon="show1 ? 'visibility' : 'visibility_off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              required
              @keyup.enter="ingresar"
            >
            </v-text-field>
            <v-flex class="red--text" v-if="error">
              {{ error }}
            </v-flex>
          </v-card-text>
          <v-card-actions class="px-3 pb-3">
            <v-btn @click="ingresar" color="primary" class="mx-auto" block
              >Ingresar</v-btn
            >
          </v-card-actions>
        </v-card>
        <!-- PreLoader -->
        <v-overlay v-model="overlay" z-index="0">
          <lottie-player
            src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
            background="transparent"
            speed="1"
            style="width: 250px; height: 250px"
            loop
            autoPlay
          />
        </v-overlay>
      </v-col>
    </v-row>
    <AsignarExtension
      v-if="userRol == 'Coordinador Cabina'"
      :visible.sync="dialogVisible"
      :token="token"
    />
    <AsignarEquipoInspector
      v-if="userRol == 'Inspector'"
      :visible.sync="dialogVisible"
      :token="token"
    />
  </v-container>
</template>

<script>
import axios from "axios";
import decode from "jwt-decode";
import AsignarExtension from "../components/AsignarExtensionCabina.vue";
import AsignarEquipoInspector from "./AsignarEquipoInspector.vue";

export default {
  components: {
    AsignarExtension,
    AsignarEquipoInspector,
  },
  data() {
    return {
      dialogVisible: false,
      userRol: null,
      equiposLibres: true,
      turnoActivo: false,
      token: null,
      email: "",
      password: "",
      error: null,
      show1: false,
      estado: 1,
      overlay: false,
    };
  },
  created() {
    this.validarAutoLogin();
  },
  methods: {
    validarAutoLogin() {
      const autoLogin = this.$route.query.auto;
      if (autoLogin) {
        this.overlay = true;

        this.dialogVisible = true;
        this.token = this.$store.state.token;
      }
    },
    async CheckChange(token, userId) {
      let header = { Authorization: "Bearer " + token };
      let configuracion = { headers: header };

      await axios
        .get(`/api/Usuarios/HasNotChange?userId=${userId}`, configuracion)
        .then((res) => {
          this.$store.commit("setHasNotChangePassword", res.data);
        })
        .catch((err) => console.error(err));
    },
    ingresar() {
      let me = this;
      me.error = null;
      me.overlay = true;
      axios
        .post("api/Usuarios/Login", {
          email: me.email,
          password: me.password,
        })
        .then(async (response) => {
          if (response.status == 200) {
            me.overlay = false;
          }
          const user = decode(response.data.token);
          const rol = user.rol;

          await this.CheckChange(response.data.token, user.idUsuario);

          if (rol == "Coordinador Cabina" || rol == "Inspector") {
            this.token = response.data.token;
            this.userRol = rol;

            let header = { Authorization: "Bearer " + response.data.token };
            let configuracion = { headers: header };

            if (rol == "Inspector") {
              await axios
                .get(
                  `api/HistorialInspectores/TurnoActivo/${user.idUsuario}`,
                  configuracion
                )
                .then((res) => {
                  if (res.status == 200) {
                    this.turnoActivo = true;
                  }
                })
                .catch((err) => console.error(err));

              if (this.turnoActivo) return response.data;

              await axios
                .get("api/Equipos/Disponibles", configuracion)
                .then((res) => {
                  if (res.data.length == 0) {
                    this.equiposLibres = false;
                  }
                })
                .catch((err) => console.error(err));

              if (this.equiposLibres) {
                //Abre Componente para Asignar Equipo
                this.dialogVisible = true;
              } else {
                //Iniciar Turno de Inspector sin Equipo
                await axios
                  .post(
                    "api/HistorialInspectores",
                    {
                      equipoId: null,
                      usuarioId: user.idUsuario,
                    },
                    configuracion
                  )
                  .then((res) => {
                    if (res.status == 200) {
                      this.$store.dispatch("guardarToken", data.token);
                      this.$router.push({ name: "novedades" });
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }
            } else {
              //Deja pasar a Cabina
              this.dialogVisible = true;
            }
          }
          return response.data;
        })
        .then((data) => {
          const userInfo = decode(data.token);
          if (!userInfo) return;

          const userRol = userInfo.rol;

          if (
            userRol == "Coordinador Cabina" ||
            (userRol == "Inspector" && this.equiposLibres && !this.turnoActivo)
          ) {
            return;
          }

          me.$store.dispatch("guardarToken", data.token);

          if (userRol == "Operador Grua") {
            this.$router.push({ name: "AsignarGrua" });
          } else {
            me.$router.push({ name: "novedades" });
          }
        })
        .catch((err) => {
          if (me.$route.params.id) {
            if (err.response.status == 400) {
              me.error = "Usuario ivalido.";
              me.overlay = false;
            }
            if (err.response.status == 404) {
              me.error = "No existe correo o contraseña incorrecta";
              me.overlay = false;
            }
          } else {
            me.error = "No se pudo iniciar sesión";
            me.overlay = false;
          }
        });
    },
  },
};
</script>

<style>
.container {
  padding: 0;
}
.color {
  background: #00d2ff;
  background: -webkit-linear-gradient(to right, #3a7bd5, #00d2ff);
  background: linear-gradient(to right, #3a7bd5, #00d2ff);
}
.colorPrueba {
  background: #ddd;
  background: -webkit-linear-gradient(to right, #ddd, #ddd);
  background: linear-gradient(to right, #ddd, #ddd);
}
</style>
